import {
  smsVerificationGetBookingVerificationStatusSuccess,
  smsVerificationVerifyBookingChangeCompleteSuccess,
  smsVerificationVerifyBookingChangeResponse,
} from '@actions/sms-verification.action';
import {
  BookingVerificationStatusTypeEnum,
  N0VerificationResponse,
} from '@models/sms-validation.model';
import { Action, createReducer, on } from '@ngrx/store';

export interface State {
  bookingVerified: BookingVerificationStatusTypeEnum | null;
  initResponse: N0VerificationResponse | null;
}

export const INITIAL_STATE: State = {
  bookingVerified: null,
  initResponse: null,
};

const reducer = createReducer(
  INITIAL_STATE,

  on(
    smsVerificationGetBookingVerificationStatusSuccess,
    (state, action): State => ({
      ...state,
      bookingVerified: action.status,
    }),
  ),

  on(
    smsVerificationVerifyBookingChangeResponse,
    (state, action): State => ({
      ...state,
      initResponse: action.response,
    }),
  ),

  on(
    smsVerificationVerifyBookingChangeCompleteSuccess,
    (state): State => ({
      ...state,
      bookingVerified: BookingVerificationStatusTypeEnum.VERIFIED,
      initResponse: null,
    }),
  ),
);

export const smsVerificationReducer = (state: State, action: Action): State =>
  reducer(state, action);
